import React from 'react';

export const CallbacksContext = React.createContext();